import { render, staticRenderFns } from "./HowToUseVictoryVoucherExplanation.vue?vue&type=template&id=196ba74c&scoped=true"
import script from "./HowToUseVictoryVoucherExplanation.vue?vue&type=script&lang=js"
export * from "./HowToUseVictoryVoucherExplanation.vue?vue&type=script&lang=js"
import style0 from "./HowToUseVictoryVoucherExplanation.vue?vue&type=style&index=0&id=196ba74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ba74c",
  null
  
)

export default component.exports